<!-- 库房报损 -->
<template>
   <div>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'"
                  :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                  @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <!-- 主要信息 -->
                     <div v-if="scope.index == 0 && scope.row.isShowForm != 1">
                        <el-form label-width="110px" id="mainInfo" class="baseForm" :show-message="false"
                           :model="sendDataInfo" ref="sendDataInfo" size="mini">
                           <el-row v-if="dataActionBox.actionType != 2">
                              <el-form-item :label="formOneValue.showField"
                                 v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                 v-if="formOneValue.isShow == 1" :prop="formOneValue.entityField"
                                 :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                 <df-date :isdisabled="formOneValue.isChange == 0"
                                    v-if="formOneValue.fieldType == 'date'"
                                    v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                 <!-- 发起类型 -->
                                 <el-select v-else-if="formOneValue.entityField == 'lomApptype'"
                                    v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择"
                                    :disabled="formOneValue.isChange == 0">
                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key"
                                       :label="item.value" :value="item.key"></el-option>
                                 </el-select>
                                 <el-input v-else-if="formOneValue.entityField == 'lomAppreason'" type="textarea"
                                    v-model.trim="sendDataInfo[formOneValue.entityField]"
                                    :maxlength="$store.state.inputLength"
                                    :disabled="formOneValue.isChange == 0"></el-input>
                                 <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]"
                                    :maxlength="$store.state.inputLength"
                                    :disabled="formOneValue.isChange == 0"></el-input>
                              </el-form-item>
                           </el-row>
                           <el-row v-if="dataActionBox.actionType == 2">
                              <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1"
                                 v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                 <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                    v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                 <span v-if="formOneValue.isRift == 1">
                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                       sendDataInfo[formOneValue.entityField] }}</a>
                                 </span>
                                 <span v-else-if="formOneValue.fieldType == 'date'">
                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                       {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                    </span>
                                 </span>
                                 <span v-else-if="formOneValue.fieldType == 'formatter'">
                                    {{ $common.getIsGsp(formOneValue.formatterContent, sendDataInfo[formOneValue.entityField])
                                    }}
                                 </span>
                                 <span
                                    v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{
                                       sendDataInfo[formOneValue.entityField]
                                          == 1 ? "是" : "否" }}</span>
                                 <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                              </el-form-item>
                           </el-row>
                        </el-form>

                        <!-- 明细 -->
                        <el-form :inline="true" size="mini">
                           <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                              <el-button type="primary" size="mini" @click="addDetails()">新增</el-button>
                              <el-button type="primary" size="mini" @click="deleteDetails()">删除
                              </el-button>
                              <el-button type="primary" size="mini" @click="extract(8820873997127697)">提取</el-button>
                           </div>
                           <el-table size="mini" ref="mxTableRef" id="mxTable" :data="sendDataInfo.lossdetailAdds"
                              border style="width: 100%" :height="mxHeight">
                              <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                 <template slot-scope="scope">
                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                       <i class="el-icon-thumb"></i>
                                    </el-radio>
                                 </template>
                              </el-table-column>
                              <el-table-column align="center" :prop="formOneValue.entityField"
                                 :label="formOneValue.showField" show-overflow-tooltip
                                 :min-width="formOneValue.fieldWeight" v-for="(formOneValue, formOneKey) in mxForm"
                                 :key="formOneKey" v-if="formOneValue.isShow == 1">
                                 <template slot-scope="scope">
                                    <!-- 商品 -->
                                    <el-input :ref="formOneValue.entityField"
                                       v-if="formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2"
                                       v-model.number="sendDataInfo.lossdetailAdds[scope.$index].bgmName"
                                       @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField)"
                                       clearable>
                                       <el-button
                                          @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField)"
                                          slot="append" icon="el-icon-search"></el-button>
                                    </el-input>
                                    <el-input :ref="formOneValue.entityField"
                                       v-else-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2"
                                       v-model.number="sendDataInfo.lossdetailAdds[scope.$index][formOneValue.entityField]"
                                       @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                       clearable>
                                       <el-button
                                          @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                          slot="append" icon="el-icon-search"></el-button>
                                    </el-input>
                                    <!-- 报损数量 -->
                                    <el-input :ref="formOneValue.entityField"
                                       v-else-if="formOneValue.entityField == 'lodNumber' && dataActionBox.actionType != 2"
                                       v-model="sendDataInfo.lossdetailAdds[scope.$index][formOneValue.entityField]"
                                       @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" type="number">
                                    </el-input>
                                    <!-- 有效期 -->
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="scope.row[formOneValue.entityField]">
                                          {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(scope.row[formOneValue.riftField])">{{
                                          scope.row[formOneValue.entityField]
                                       }}</a>
                                    </span>
                                    <span v-else>
                                       {{ sendDataInfo.lossdetailAdds[scope.$index][formOneValue.entityField] }}
                                    </span>
                                 </template>
                              </el-table-column>

                           </el-table>
                        </el-form>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <!-- 页脚 -->
            <div class="foot">
               <div>
                  <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                     @click="showPrintPlan">打印
                  </el-button>
                  <el-button type="primary" @click="initActionBox('sendDataInfo')"
                     v-if="dataActionBox.actionType != 2">取消</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                     v-if="dataActionBox.actionType == 0">保存</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                     v-if="dataActionBox.actionType == 1">保存</el-button>
               </div>
               <div v-if="footForm">
                  <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                     <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                        <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                     </el-form-item>
                  </el-form>
               </div>
            </div>
         </div>
      </div>
      <!-- 检索方案弹窗 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
         :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
            @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "stockLossAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            lomAppreason: "",
            lomApptype: 0,
            lomReserves1: "",
            lomReserves2: "",
            lomReserves3: "",
            lomReserves4: "",
            lomReserves5: "",
            lomReserves6: "",
            lomId: "",
            lossdetailAdds: [],
            totalMoney: 0,
            totalNumber: 0,
            totalCount: 0,
         },
         detaislDataInfo: {},
         selectGoodsInfo: "",
         showTabs: "",
         formDataList: [],
         parentSearchData: {},
         seTitle: "", //检索
         DialogVisible: false,
         seWidth: "0",
         seId: 0,
         selectedDetailsIndex: 0, //选择索引
         focusIndex: 0, //检索焦点索引
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.lossdetailAdds": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.totalCount = 0; //总条目数
            this.sendDataInfo.totalMoney = 0; // 总金额
            this.sendDataInfo.totalNumber = 0; // 总数量
            newValue.forEach((item, keys) => {
               // 修改判断条件，允许正小数（大于0的数），而不仅仅是整数
               if (item.lodNumber < 0 || item.lodNumber > item.num) {
                  this.sendDataInfo.lossdetailAdds[keys].money = 0;
                  this.sendDataInfo.lossdetailAdds[keys].psmoney = 0;
                  this.sendDataInfo.lossdetailAdds[keys].lodNumber = 0;
                  return false;
               }
               // 计算金额 单价*数量
               this.sendDataInfo.lossdetailAdds[keys].money =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(item.price, item.lodNumber)
                  );

               // 计算含税金额 含税价格*数量
               this.sendDataInfo.lossdetailAdds[keys].psmoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(item.psprice, item.lodNumber)
                  );

               this.sendDataInfo.totalMoney = NP.plus(
                  this.sendDataInfo.totalMoney,
                  this.sendDataInfo.lossdetailAdds[keys].psmoney
               );

               this.sendDataInfo.totalNumber = NP.plus(
                  this.sendDataInfo.totalNumber,
                  item.lodNumber
               );
            });
            this.sendDataInfo.totalCount = newValue.length;
         },

         deep: true,
      },
   },
   //方法集合
   methods: {
      extract(sId) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seType = "extract";
         this.parentSearchData.foType = 0
         console.log(this.sendDataInfo);
         // this.seIndex
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      // 子组件穿透方法
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2)
            this.$parent.$parent.toDetail(orderId);
         else this.$parent.$parent.$parent.toDetail(orderId);
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type) {
         this.focusIndex = index;
         this.DialogVisible = true;
         this.seId = sId;
         this.parentSearchData[type] =
            this.sendDataInfo.lossdetailAdds[index][type];
         if (type == "lotno") {
            for (const key in this.sendDataInfo.lossdetailAdds[index]) {
               this.parentSearchData[key] =
                  this.sendDataInfo.lossdetailAdds[index][key];
            }
         }
      },
      //检索带回数据
      changeInputModel(val) {
         console.log("返hui", val, this.sendDataInfo.lossdetailAdds);
         if (val != "" || val != undefined) {
            this.DialogVisible = false; //关闭商品检索窗口
            //赋值给当前行
            if (this.sendDataInfo.lossdetailAdds.length == 0) {
               this.sendDataInfo.lossdetailAdds.push({})
            }
            if (val.bgmId)
               for (const key in val) {
                  if (Object.hasOwnProperty.call(val, key)) {
                     this.$set(
                        this.sendDataInfo.lossdetailAdds[this.focusIndex],
                        key,
                        val[key]
                     );
                  }
               }
            this.tableNextFocus("lodNumber", this.seIndex);
         }





      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      // 确认新增
      async sendDataAction(formName) {
         let flag = false;
         this.$refs[formName].validate((valid) => {
            if (valid) {
            } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               flag = true;
               return false;
            }
         });
         if (flag) return false;
         //检查每个明细的报损数量
         let numFlag = this.sendDataInfo.lossdetailAdds.every(
            (v) => v.lodNumber > 0
         );
         if (!numFlag) {
            this.$message({
               message: "报损数量必须大于0",
               type: "error",
            });
            return false;
         }
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.addStorageRoomLoss(sendData);
         } else {
            var responseData = await this.$http.setStorageRoomLoss(sendData);
         }
         if (responseData.status == 200) {
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit("drawerCancel", 1);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //取消新增
      initActionBox(formName) {
         this.$confirm("确定取消吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.init();
               this.$emit("drawerCancel", 0);
               this.$refs[formName].resetFields();
            })
            .catch(() => { });
      },

      async isShowData(name, value) {
         this.sendDataInfo[name] = value;
      },
      //新增明细
      addDetails() {
         //bgmId
         var flag = false;
         if (this.sendDataInfo.lossdetailAdds.length > 0) {
            this.sendDataInfo.lossdetailAdds.forEach((item) => {
               if (item.bgmId == "") {
                  flag = true;
                  this.$nextTick(() => {
                     this.selectedDetailsIndex = Number(
                        this.sendDataInfo.lossdetailAdds.length - 1
                     );
                     this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                     let refsElTable = this.$refs.mxTableRef;
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(
                        this.sendDataInfo.lossdetailAdds[
                        this.selectedDetailsIndex
                        ]
                     );
                  });
               }
            });
         }
         if (flag) {
            return;
         }
         this.sendDataInfo.lossdetailAdds.push({});
         var index = this.sendDataInfo.lossdetailAdds.length - 1;
         for (const key in this.detaislDataInfo) {
            this.$set(
               this.sendDataInfo.lossdetailAdds[index],
               key,
               this.detaislDataInfo[key]
            );
         }
         this.$nextTick(() => {
            this.selectedDetailsIndex = Number(
               this.sendDataInfo.lossdetailAdds.length - 1
            );
            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
               this.sendDataInfo.lossdetailAdds[this.selectedDetailsIndex]
            );
         });
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         this.seIndex = index;
         if (field == "keydown") {
            if (this.sendDataInfo.lossdetailAdds[index + 1] != undefined) {
               this.$refs["bgmName"][index + 1].focus();
               this.selectedDetailsIndex = index + 1;
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.lossdetailAdds[this.selectedDetailsIndex]
                  );
               });
               return;
            }
            this.addDetails("sendDataInfo");
            return;
         }
         this.$refs[field][index].focus();
      },
      //删除明细
      deleteDetails() {
         if (this.sendDataInfo.lossdetailAdds.length < 1) {
            this.$message({
               message: "请先添加明细",
               type: "error",
            });
            return false;
         }
         this.sendDataInfo.lossdetailAdds.splice(this.selectedDetailsIndex, 1);
         this.selectedDetailsIndex = 0;
      },
      // 初始化
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.totalCount = 0; //总条目数
         this.sendDataInfo.totalMoney = 0; // 总金额
         this.sendDataInfo.totalNumber = 0; // 总数量

         this.sendDataInfo.lomApptype = 0;
         this.sendDataInfo.lossdetailAdds = [];

         // this.dataActionBox.actionType = 0
      },
      //父级传入
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;

         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.filterMainField();
         this.init();

         console.log(this.dataActionBox.actionType, "2222");
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            // var _this = this
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
            this.$set(this.sendDataInfo, "lossdetailAdds", []);
            dataInfo.lossdetailInfos.forEach(async (item, keys) => {
               this.sendDataInfo.lossdetailAdds.push(item);
            });
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
            this.$set(this.sendDataInfo, "lossdetailAdds", []);
            dataInfo.lossdetailInfos.forEach(async (item, keys) => {
               this.sendDataInfo.lossdetailAdds.push(item);
            });
            console.log(this.sendDataInfo.lossdetailAdds, "8888");
         }

         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight();
               } else {
                  this.mxHeight = this.$common.getHeight();
               }
            }, 16.7);
         });
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
               this.mxForm.forEach((item1) => {
                  if (item1.fieldType == "number") {
                     this.$set(this.detaislDataInfo, item1.entityField, 0);
                  } else if (item1.fieldType == "search" && item1.setField) {
                     var arr = item1.setField.split(",");
                     arr.forEach((item2) => {
                        this.$set(this.detaislDataInfo, item2, "");
                     });
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "");
                  }
               });
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });
         var arr = [{ entityField: "lossdetailAdds" }];
         var obj = this.$common.filterMainFields(
            this.formDataList,
            arr,
            mainFormList[0]
         );
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key]);
         }
         this.$set(this.sendDataInfo, "lomApptype", 0);
         this.$set(this.sendDataInfo, "actionType", 0);
         this.showTabs = this.tabForm[0].jciName;
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox();
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
   width: 100%;
}

.el-drawer {
   outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}
</style>